import { DialogContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import '../../../assets/styles/modals.css';

const useStyles = makeStyles((theme) => ({
    noVerticalScroll: {
        overflowY: 'hidden',
        height:'100vh'
    },
}));

export const ModalBody = (props:any) => {

    const { children, noscroll } = props;
    const classes = useStyles();

    return (
        <DialogContent dividers className={noscroll ? classes.noVerticalScroll : ''}>
            {children}
        </DialogContent>
    )
}
